import videojs from 'video.js';

class VideoControl {
  constructor(element) {
    this.el = element;
    this._playerInit();
  }

  _playerInit() {
    this.player = videojs(this.el, {
      fluid: true,
      aspectRatio: '192:108',
      autoplay: false,
      preload: 'auto',
      fill: true,
      responsive: true,
      loadingSpinner: true,
      languages: {
        ja: {
          Play: '再生',
          Pause: '停止',
          'Play Video': '再生',
          Mute: '消音',
          'Playback Rate': '再生速度',
          'Picture-in-Picture': 'ピクチャインピクチャ',
          Fullscreen: '全画面表示',
          'Non-Fullscreen': '通常表示',
        },
      },
      language: 'ja',
      controlBar: {
        downloadButton: false,
      },
    });
  }
}

export { VideoControl };
